import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const ListDiagram = ({ items, testId }) => {
  const [open, setOpen] = useState(0);
  return (
    <ol className="max-w-[60ch]" data-testid={`${testId}-list`}>
      {items.map(([title, text], i) => (
        <li key={title} className="border-t border-[#0D1B2A]/15">
          <button
            type="button"
            onClick={() => setOpen(open === i ? -1 : i)}
            aria-expanded={open === i}
            className="w-full text-left py-5 grid grid-cols-[2.5rem_1fr_1.5rem] gap-3 items-baseline"
            data-testid={`${testId}-item-${i}`}
          >
            <span className="mono text-xs text-[#595959]">0{i + 1}</span>
            <span className="text-base md:text-lg font-medium tracking-tight">{title}</span>
            <span className="mono text-xs text-[#595959] text-right">{open === i ? "—" : "+"}</span>
          </button>
          <AnimatePresence initial={false}>
            {open === i && (
              <motion.p
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                className="body-copy overflow-hidden pl-[3.25rem] pb-5"
                data-testid={`${testId}-item-${i}-body`}
              >
                {text}
              </motion.p>
            )}
          </AnimatePresence>
        </li>
      ))}
      <li className="border-t border-[#0D1B2A]/15" />
    </ol>
  );
};
